export default class SchemaService {
  constructor(firebase, AuthService, FEService, TemplateService) {
    'ngInject';
    this.AuthService = AuthService;
    this.fe = FEService;
    this.ts = TemplateService;
    this.reset(); //initialize/reset this variables
    
    firebase.auth().onAuthStateChanged(_ => this.reset()); // Clear stashed data;
  }
  
  reset() {
    this._schemas = {};
    this._granted = {};
  }
  
  get schemas() {
    return this.ts.references
      ? this.ts.references.reduce((a,r) => ({...a, [r.tableId]: r.tableSchema}), {})
      : {};
  }
  
  async getGrantedDBs() {
    const realm = await this.AuthService.realm();
    if (!realm) {
      console.error("No Realm available when getting Granted.");
      return [];
    } else if (!this._granted[realm]) { 
      this._granted[realm] = this.queryGrantedDBs(); 
    }
    return await this._granted[realm];
  }
  
  async queryGrantedDBs() {
    const { "data": { granted } } = await this.fe.httpsCallable('grantedDbs');
    return granted;
  }
  
  validConnection(template, promptValues=[], ignoreStoredConn=false){
    return this.fe.httpsCallable('validConnection', { template: this.ts.toRaw({template}), promptValues, ignoreStoredConn });
  }

  getRealmConnections(options){
    return this.fe.httpsCallable('getRealmConnections', options);
  }

  deleteUserConnection(connectionId){
    return this.fe.httpsCallable('deleteUserConnection', {connectionId});
  }

  // Still needed when adding tables that are not part of existing schemas.
  async getSchema(template, tableId){
    try {
      const {tableSchema} = template.references.find(r => r.tableId == tableId) || {};
      // Give priority to template, it is updated after save (in case new fields exist, for example)
      this._schemas[tableId] = (tableSchema || this._schemas[tableId]);
      if (!(this._schemas[tableId]?.fields)){
        const connection = await this.AuthService.suppliedConnection();
        const params = { template: this.ts.toRaw(), tableId, connection };
        const { "data": { schema } } = await this.fe.httpsCallable('getSchema', params);
        this._schemas[tableId] = schema;
      }
    } catch(err) {
      console.error(err);
    }
    
    return this._schemas[tableId];
  }

  getTemplateSchemas(template){
    return template.references.reduce((acc, ref) => { acc[ref.tableId] = ref.tableSchema; return acc; }, {} );
  }

  getTableSchemaRequiredFields(tableSchema) {
    return tableSchema?.fields.filter(f => f.isRequired).map(f => f.id) || [];
  }
}
